import { httpClient } from '@/utils/httpClient';
import { provisioningFlight, setProvisioningFlight } from './provisioningFlight';

/**
 * Single-flight POST /api/rest/app/v1/users/me (provision_me).
 *
 * Provisioning is idempotent and fired from several places on login (the OAuth
 * callback — double-invoked under React StrictMode — and the activity heartbeat
 * that runs the moment MainLayout mounts). The shared provisioningFlight state
 * (also used by triggerJitProvisioning) collapses concurrent calls from ANY
 * provisioning code path into one request; a new request starts only after the
 * previous one settles.
 */
export const provisionCurrentUser = (): Promise<void> => {
  if (provisioningFlight) return provisioningFlight;
  const flight = httpClient
    .post('/api/rest/app/v1/users/me', {})
    .then(() => undefined)
    .finally(() => {
      setProvisioningFlight(null);
    });
  setProvisioningFlight(flight);
  return flight;
};
